const breakpoints = {
  smallPhoneShorterEdge: 320,
  mediumPhoneShorterEdge: 414,
  bigPhoneShorterEdge: 480,
};

export default {
  breakpoints,
};
